<template>
    <wc-button
        class="btn btn-danger"
        v-on:click="onClick"
    >
        {{ label }}
    </wc-button>
</template>

<script>
import axios from "axios";
import "@25sprout-internal/wc-button";
import { config, apiPath } from "@backstagex/core/src/config";
import { abstractField } from "@backstagex-vue-form-generator/core";
export default {
    mixins: [abstractField],
    props: ["schema", "model"],
    data: function () {
        return {
            label: "取消報名",
        };
    },
    methods: {
        onClick() {
            if (this.$route.name === "create") return;
            var confirm = window.confirm("您確定將取消此已預約課程/活動？");
            if (confirm) {
                axios
                    .put(
                        config.apiHost +
                            "/api/backstagex/" +
                            this.$route.params.menuItemKey +
                            "/" +
                            this.$route.params.id +
                            "/cancel-course-booking"
                    )
                    .then((response) => {
                        if (response.data.status === 200) {
                            alert("取消成功");
                            this.$router.go(0);
                        } else {
                            alert("取消失敗");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>